<template>
  <MarketInsightsPage
    v-slot="{ slug, categoriesArticles, playVideo }"
    :market="NATURAL_GRAPHITE"
  >
    <NuxtPage
      :slug="slug"
      :categories-articles="categoriesArticles"
      :categories-videos="categoriesArticles"
      @play-video="playVideo"
    />
  </MarketInsightsPage>
</template>

<script setup lang="ts">
import MarketInsightsPage from '~/components/market/MarketInsightsPage.vue'
import { NATURAL_GRAPHITE, MARKET } from '~/constants/services/constants'

const { getSeoInfo } = useSeo()

const seo = getSeoInfo({
  title: `${MARKET.name}: ${NATURAL_GRAPHITE.name} Market Insights`,
})
useHead(seo)

definePageMeta({ layout: 'services' })
</script>
